__webpack_require__.p = "https://cart.dev.core-artifacts.com/static/";